export const authorizedCountries = [
  "GB",
  "FR",
  "ES",
  "IT",
  "PT",
  "CN",
  "DE",
  "RU",
  "RO",
  "TR",
  "JP",
  "US",
  "GR",
  "FI",
  "HR",
  "DK",
  "RS",
  "BR",
];
